import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'

@reduxForm({
  form: 'accountEditTeam',
})
export default class EditTeamForm extends Component {
  static defaultProps = {
    onSubmit: () => {},
  }
  render() {
    const { onSubmit, error, handleSubmit, submitting } = this.props

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <p>
          Set the limits for team {this.props.initialValues.name}. Leave blank
          for no limit.
        </p>

        <div className="form-group">
          <label>Number of allowed users</label>
          <Field
            name="allowedNumUsers"
            component="input"
            placeholder="No limit set"
            type="text"
            className="form-control"
          />
        </div>

        <div className="form-group">
          <label>Number of allowed briefings</label>
          <Field
            name="allowedNumBriefings"
            component="input"
            placeholder="No limit set"
            type="text"
            className="form-control"
          />
        </div>

        <div className="form-group">
          <label>Number of allowed folders</label>
          <Field
            name="allowedNumBoards"
            component="input"
            placeholder="No limit set"
            type="text"
            className="form-control"
          />
        </div>

        <div className="form-group">
          <label>Number of allowed briefings exposed via the API</label>
          <Field
            name="allowedNumApiBriefings"
            component="input"
            placeholder="No limit set"
            type="text"
            className="form-control"
          />
        </div>

        <div className="form-group">
          <label>Number of allowed folders exposed via the API</label>
          <Field
            name="allowedNumApiBoards"
            component="input"
            placeholder="No limit set"
            type="text"
            className="form-control"
          />
        </div>

        <div className="form-group">
          <label>Number of allowed briefings publicly exposed</label>
          <Field
            name="allowedNumPublicBriefings"
            component="input"
            placeholder="No limit set"
            type="text"
            className="form-control"
          />
        </div>

        <div className="form-group">
          <label>Number of allowed folders publicly exposed</label>
          <Field
            name="allowedNumPublicBoards"
            component="input"
            placeholder="No limit set"
            type="text"
            className="form-control"
          />
        </div>

        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}

        <button type="submit" className="btn btn-primary" disabled={submitting}>
          Update
        </button>
      </form>
    )
  }
}
